module.exports = __webpack_public_path__ + "img/dyg.7ec6d0e4.png";